import React from "react";
import Select from "react-select";

import Header from "../../components/dashboard-title";
import {
  ACTIVITY_FEED_FILTER_ALL,
  ACTIVITY_FEED_FILTER_OPTIONS,
} from "./activity-feed-list-utils";
import "../../components/list-popup/list-popup.css";

const TYPE_OPTIONS = Object.keys(ACTIVITY_FEED_FILTER_OPTIONS).map((key) => ({
  value: key,
  label: ACTIVITY_FEED_FILTER_OPTIONS[key],
  color: "grey",
}));

/** Same control chrome as Communities / User (MultiSelectionListPopup). */
const customStyles = {
  control: () => ({
    minWidth: "140px",
    display: "flex",
    borderRadius: "4px",
    alignItems: "center",
    " > div": {
      padding: "0",
    },
    "&:hover": {
      cursor: "pointer",
    },
  }),
  indicatorsContainer: () => ({
    alignItems: "end",
    display: "flex",
  }),
  singleValue: () => ({
    fontSize: "16px",
    fontWeight: "400",
    opacity: "0.8",
    padding: "0",
    color: "white",
    marginTop: "0.4rem",
  }),
  dropdownIndicator: () => ({
    color: "white",
    padding: "8px",
    " > svg": {
      width: "19px",
    },
  }),
  menu: () => ({
    background: "#191b1d",
    position: "absolute",
    minWidth: "200px",
    border: "none",
    borderRadius: "3px",
    zIndex: 3000,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "0",
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 3000,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  placeholder: () => ({
    fontSize: "16px",
    fontWeight: "400",
    opacity: "0.8",
    padding: "0",
    color: "white",
    marginTop: "0.4rem",
  }),
  option: (provided, state) => ({
    backgroundColor: state.isSelected || state.isFocused ? "#333" : "black",
    border: "none",
    padding: "0.5rem 0.8rem",
    color: state.isSelected || state.isFocused ? "#80b602" : "#d8d8d8",
    fontSize: "0.9em",
    "&:hover": {
      backgroundColor: "#333",
      color: "#80b602",
      cursor: "pointer",
    },
  }),
};

/**
 * Types filter — same react-select toolbar look as Communities / User.
 */
const ActivityFeedTypeFilter = ({ value, onChange }) => {
  const selected =
    TYPE_OPTIONS.find((opt) => opt.value === value) || TYPE_OPTIONS[0];

  return (
    <div>
      <div className="toolbarSelect activity-feed-type-filter">
        <div className="d-flex justify-content">
          <Header title="Types" />
        </div>
        <div className="d-flex justify-content-between align-items-baseline">
          <Select
            options={TYPE_OPTIONS}
            styles={customStyles}
            isSearchable={false}
            isMulti={false}
            value={selected}
            onChange={(opt) => onChange(opt?.value || ACTIVITY_FEED_FILTER_ALL)}
            menuPortalTarget={
              typeof document !== "undefined" ? document.body : null
            }
            menuPosition="fixed"
          />
        </div>
      </div>
    </div>
  );
};

ActivityFeedTypeFilter.defaultProps = {
  value: ACTIVITY_FEED_FILTER_ALL,
};

export default ActivityFeedTypeFilter;
